import { css } from 'lit';

export const planeConfirmStyles = css`
  dialog {
    width: min(var(--dialog-width), calc(100vw - 2 * var(--page-gutter-narrow)));
    padding: var(--space-5);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface-raised);
    color: var(--text);
    font-family: var(--font-sans);
    box-shadow: var(--shadow-float);
  }

  dialog::backdrop {
    background: var(--backdrop);
  }

  h2 {
    margin: 0 0 var(--space-3);
    font-family: var(--font-display);
    font-weight: var(--font-display-weight);
    font-size: var(--font-size-xl);
    line-height: var(--line-height-snug);
    letter-spacing: var(--font-display-tracking);
  }

  p {
    margin: 0;
    line-height: var(--line-height-body);
    color: var(--text-muted);
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: var(--space-2);
    margin-top: var(--space-5);
  }

  button.danger.confirm {
    background: var(--tone-danger);
    border-color: var(--tone-danger);
    color: var(--surface-raised);
  }

  button.danger.confirm:hover:not(:disabled) {
    background: var(--tone-danger);
    filter: brightness(var(--hover-brightness));
  }
`;
